import { render, staticRenderFns } from "./SalaEscola.vue?vue&type=template&id=2ae2b790&"
import script from "./SalaEscola.vue?vue&type=script&lang=js&"
export * from "./SalaEscola.vue?vue&type=script&lang=js&"
import style0 from "./SalaEscola.vue?vue&type=style&index=0&id=2ae2b790&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports